import axios from "axios";
import { toast } from "react-toastify";
import { usersActions } from "../slice/userSlice";
import { getAdminAuthHeaders } from "../../utils/adminApi";

export const getAllUser = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        "https://api.michelbandalidesign.com/api/user/"
      );
      dispatch(usersActions.setUsers(response.data));
    } catch (error) {
      console.log(error);
      toast.error("bad connection ");
    }
  };
};

export const deleteUser = (userId) => {
  return async (dispatch) => {
    try {
      await axios.delete(
        `https://api.michelbandalidesign.com/api/user/${userId}`,
        { headers: getAdminAuthHeaders() }
      );
      dispatch(usersActions.deleteUser(userId));
      toast.success("User deleted successfully");
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to delete user. Make sure you are logged in as admin.";
      toast.error(message);
      throw error;
    }
  };
};
